module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abbreviations and Glossary")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos1"
    }
  }, [_vm._v("AaM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Abteiarchiv [Abbey Archive] Muensterschwarzach")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos2",
      "id": "glos2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abwehr")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("German Secret Service, namely the intelligence, counter-intelligence and sabotage service of the High Command of the Wehrmacht")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos3"
    }
  }, [_vm._v("AdIfZ")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Archiv des Instituts fuer Zeitgeschichte [Institute for Contemporary History (Munich)]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos4"
    }
  }, [_vm._v("Axis")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Association of Germany and Italy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos5"
    }
  }, [_vm._v("BAK")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Bundesarchiv Koblenz")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos6"
    }
  }, [_vm._v("BAP")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Bundesarchiv Potsdam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos7",
      "id": "glos7"
    }
  }, [_vm._v("BBC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("British Broadcasting Corporation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos8"
    }
  }, [_vm._v("BDC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Berlin Document Centre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos9"
    }
  }, [_vm._v("BHSA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Bayerisches Hauptsstaatsarchiv [Bavarian Main State Archive]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos10"
    }
  }, [_vm._v("BL")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("British Library")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos11",
      "id": "glos11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Black’")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Opprobrious term for German Catholics")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos12"
    }
  }, [_vm._v("Bundesarchiv")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("German Federal Archive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos13"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Letter denoting either the Chief of the Secret Intelligence Service or the Service itself")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos14"
    }
  }, [_vm._v("CCG (BE)")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Control Commission for Germany (British Element)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos15"
    }
  }, [_vm._v("CE")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Counter-Espionage")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos16"
    }
  }, [_vm._v("CIA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Central Intelligence Agency [USA]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#rglos17",
      "id": "glos17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CIC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Counter Intelligence Corps [USA]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos18"
    }
  }, [_vm._v("C in C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Commander in Chief")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos19"
    }
  }, [_vm._v("COS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Chiefs of Staff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos20"
    }
  }, [_vm._v("Cossac")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Chief of Staff to the Supreme Allied Commander")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#rglos21",
      "id": "glos21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CSDIC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Combined Services Detailed Interrogation Centre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#rglos22",
      "id": "glos22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CSU")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Christliche Soziale Union [Bavarian]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos23"
    }
  }, [_vm._v("DBFPFS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Documents on British Foreign Policy first series")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos24"
    }
  }, [_vm._v("Deutsche Arbeitsfront [DAF]")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("German Labour Front")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos25"
    }
  }, [_vm._v("Enigma")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("German coding machine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos26"
    }
  }, [_vm._v("Fifth Columnists")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Hidden subversive elements controlled by Fascists")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos27"
    }
  }, [_vm._v("FO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Foreign Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos28",
      "id": "glos28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontbann")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Ernst Roehm’s organisation for military training of radical right")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos29",
      "id": "glos29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gauleiter")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Regional leader of the Nazi Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos30"
    }
  }, [_vm._v("GC & CS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Government Code and Cypher School with responsibility for devising British codes and breaking foreign ones")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos31"
    }
  }, [_vm._v("GHQ")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("General Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos32",
      "id": "glos32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gruppenfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to lieutenant general [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos33"
    }
  }, [_vm._v("GSO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("General Staff Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#rglos34",
      "id": "glos34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hauptsturmfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to captain [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos35"
    }
  }, [_vm._v("HMG")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("His Majesty’s Government")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos36"
    }
  }, [_vm._v("Humint")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Intelligence from human sources")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos37",
      "id": "glos37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intendantur Ley")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Agency of Robert Ley, head of organisation of the Nazi Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos38"
    }
  }, [_vm._v("IWM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Imperial War Museum")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#rglos39",
      "id": "glos39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JIC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Joint Intelligence Sub-Committee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "rglos40"
    }
  }, [_vm._v("KGB")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Soviet security and intelligence agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos41",
      "id": "glos41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kreisleiter")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("District leader [of Nazi Party]: the lowest rung of its salaried officials")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#rglos42",
      "id": "glos42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kulturkampf")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Bismarck’s attempt to restrict the Catholic Church in Germany")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos43"
    }
  }, [_vm._v("LAB")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Landesarchiv Berlin")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos44",
      "id": "glos44"
    }
  }, [_vm._v("MI5")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("British Security Service: agency responsible for preventing espionage, sabotage and subversion on UK territory")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#rglos45",
      "id": "glos45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MI6")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Popular name for Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos46"
    }
  }, [_vm._v("MO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Medical Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos47",
      "id": "glos47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Napola")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nationalpolitische Erziehungsanstalt: National Political Educational Institute: an ‘elite’ Nazi secondary school")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos48",
      "id": "glos48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NSDAP")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nationalsozialistische Deutsche Arbeiter Partei: National Socialist German Workers’ Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#rglos49",
      "id": "glos49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Beginning")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Movement of revolutionary socialist cadres within Third Reich")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos50",
      "id": "glos50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obergruppenfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to general [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter06#rglos51",
      "id": "glos51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obersturmbannfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to lieutenant colonel [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos52"
    }
  }, [_vm._v("OSB")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Order of Saint Benedict")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "glos53"
    }
  }, [_vm._v("OSS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("American Office of Strategic Services, precursor of CIA")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#rglos54",
      "id": "glos54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PID")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Political Intelligence Division [of the British Foreign Office]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos55"
    }
  }, [_vm._v("POW")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Prisoner of war")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos56"
    }
  }, [_vm._v("PS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Private Secretary")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos57",
      "id": "glos57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PWE")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Political Warfare Executive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos58",
      "id": "glos58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reichsgau")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("One of eleven regions established after Germany’s annexations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos59",
      "id": "glos59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RSHA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Reichssicherheitshauptamt: Reich Security Head Office, with authority over the Gestapo, Criminal Police and SD")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "rglos60"
    }
  }, [_vm._v("RSS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Radio Security Service: British organisation for intercepting the wireless messages of foreign spies during the Second World War")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos61",
      "id": "glos61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Sturmabteilung: Storm Troops of the Nazi Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos62"
    }
  }, [_vm._v("SAW")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Staatsarchiv Wuerzburg")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos63",
      "id": "glos63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Sicherheitsdienst: Nazi Party security service within the SS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter05#rglos64",
      "id": "glos64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHAEF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Supreme Headquarters Allied Expeditionary Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos65"
    }
  }, [_vm._v("Sigint")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Intelligence from the interception and decryption of signals")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos66",
      "id": "glos66"
    }
  }, [_vm._v("SIS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("British Secret Intelligence Service, also known as MI6: responsible for gathering intelligence and counter-intelligence outside UK territory")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos67",
      "id": "glos67"
    }
  }, [_vm._v("SOE")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("British Special Operations Executive: responsible for sabotage, subversion and fomenting resistance overseas")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos68",
      "id": "glos68"
    }
  }, [_vm._v("SO1")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("SOE department for secretly spreading misinformation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#rglos69",
      "id": "glos69"
    }
  }, [_vm._v("SO2")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("SOE department for stimulating resistance and organising sabotage")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#rglos70",
      "id": "glos70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sopade")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Social Democratic Party of Germany [in exile]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos71",
      "id": "glos71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Schutzstaffel: protection squad of the Nazi Party")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos72",
      "id": "glos72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stahlhelm")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Steel Helmet: right-wing paramilitary organisation of German veterans")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos73",
      "id": "glos73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standartenfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to colonel [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter04#rglos74",
      "id": "glos74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sturmbannfuehrer")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Nazi paramilitary rank equivalent to major [UK army]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos75"
    }
  }, [_vm._v("TNA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("The National Archives [UK]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "rglos76"
    }
  }, [_vm._v("UK")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("United Kingdom")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "rglos74a"
    }
  }, [_vm._v("Ultra")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Security classification for intelligence derived from decoding German wireless messages enciphered by the Enigma machine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos77"
    }
  }, [_vm._v("VOMI")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Volksdeutsche Mittelstelle")]), _vm._v(": Liaison Office for Ethnic Germans [with responsibility for their resettlement]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos78"
    }
  }, [_vm._v("USSR")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Union of Soviet Socialist Republics")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#rglos79",
      "id": "glos79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wehrmacht")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("German Armed Forces")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos80"
    }
  }, [_vm._v("WLL")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("Wiener Library London [now Wiener Holocaust Library]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "rglos81"
    }
  }, [_vm._v("WO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_vm._v("War Office")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ae08a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Glossary.vue
// module id = 75
// module chunks = 0